import { GenericService } from './generic.service';
import { User } from '@/models';

export class UsersService extends GenericService<User> {
  endpoint = 'v1/users';
}
